import { render, staticRenderFns } from "./StepsNavFork.vue?vue&type=template&id=671401fd&scoped=true"
import script from "./StepsNavFork.vue?vue&type=script&lang=js"
export * from "./StepsNavFork.vue?vue&type=script&lang=js"
import style0 from "./StepsNavFork.vue?vue&type=style&index=0&id=671401fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671401fd",
  null
  
)

export default component.exports